import { Log, RouteSelectionMode } from '@/types/logs'
import { OfficialReportType } from '@/types/officialReport'
import { FormValuesType } from '../schema'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../constant'
import { getTakeoverDifferenceInMinutes } from './getTakeoverDifferenceInMinutes'
import { isHeadwayValid } from './isHeadwayValid'

export const buildDescription = (reportType: OfficialReportType, log: Log, values: FormValuesType): string => {
    const routes = log.routeSelectionMode !== RouteSelectionMode.None ? log.routes?.join(' ') || '-' : '-'
    const location = values[OFFICIAL_REPORT_FORM_FIELDS.locationOfIssue] || '-'
    const duty = log.duty || '-'
    const run = log.run || '-'
    const driverStatement = (values[OFFICIAL_REPORT_FORM_FIELDS.driverStatement] || '').replace(/\n/g, '<br>')

    switch (reportType) {
        case OfficialReportType.LateTakeover: {
            const takeoverTime = values[OFFICIAL_REPORT_FORM_FIELDS.takeoverTime] || '-'
            const actualTakeoverTime = values[OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime] || '-'
            const dateOfIssue = values[OFFICIAL_REPORT_FORM_FIELDS.dateOfIssue]
            const diff = dateOfIssue
                ? getTakeoverDifferenceInMinutes({ dateOfIssue, takeoverTime, actualTakeoverTime })
                : 0
            return `The bus with running number ${run} on the route ${routes} was observed stationary at ${location}. The vehicle was taken over at ${actualTakeoverTime}, ${diff} minutes later than the ${takeoverTime} takeover time. The bus was called and the driver of duty ${duty} was questioned about the late takeover. The driver stated: ${driverStatement}`
        }
        case OfficialReportType.LateDeparture: {
            const takeoverTime = values[OFFICIAL_REPORT_FORM_FIELDS.takeoverTime] || '-'
            const actualTakeoverTime = values[OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime] || '-'
            const timeType = values[OFFICIAL_REPORT_FORM_FIELDS.timeType]?.toLowerCase() || '-'
            const dateOfIssue = values[OFFICIAL_REPORT_FORM_FIELDS.dateOfIssue]
            const diff = dateOfIssue
                ? getTakeoverDifferenceInMinutes({ dateOfIssue, takeoverTime, actualTakeoverTime })
                : 0
            return `The bus with running number ${run} on the route ${routes} was observed departing ${location} at ${actualTakeoverTime}, running ${diff} minutes later than the ${timeType} departure time. The bus was called and the driver of duty ${duty} was questioned about the late running. The driver stated: ${driverStatement}`
        }
        case OfficialReportType.Headway: {
            const headways = values[OFFICIAL_REPORT_FORM_FIELDS.headways] || []
            const headwayList = headways
                .filter(isHeadwayValid)
                .map((item) => `${item.observedAt} ${item.busStop} - headway ${item.headway}`)
                .join('<br>')
            return `The bus with running number ${run} on the route ${routes} was observed at ${location} running with inappropriate headway in relation to the following and leading bus. The bus was called and the driver of duty ${duty} was given instructions to even out the headway based on MDT. The bus continued running in service with inappropriate headways at the following locations:<br>${headwayList}<br><br>The driver stated: ${driverStatement}`
        }
        default:
            return ''
    }
}
